import api from './default'

export default api('/api/contact', 'contacts')
